import React from 'react';
import ReactDOM from 'react-dom';

// import Select from 'react-select';
//import 'react-select/dist/react-select.css';

import Select, { components } from 'react-select';
import { deepCopy } from '../util';


class ProductSelect extends React.Component {
  constructor (props){
    super(props)

    this.onChange = this.onChange.bind(this)
    this.getInitialValue = this.getInitialValue.bind(this)

    this.value = this.getInitialValue();
  }

  getInitialValue() {
    var value = this.props.value ? deepCopy(this.props.value) : this.props.options[0];
    return value
  }

  onChange(value) {
    this.value = value;

    if(this.props.onChange != undefined){
      this.props.onChange(value);  
    }
            
    // because we don't change the state we need to force rerendering
    this.forceUpdate();  
  }
  
  render() {
    if(this.props.externalValue != undefined){
      this.value = this.props.value
    }
    return (
        <Select 
          name={this.props.name} 
          options={this.props.options} 
          value={this.value} 
          onChange={this.onChange} 
          isSearchable={true} 
          isClearable={false} />
    );
  }
}

export default ProductSelect